import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import WinesPage from '@/pages/vinhos/page';
import VinegarPage from '@/pages/vinagre/page';
import JuicePage from '@/pages/suco/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/vinhos', element: <WinesPage /> },
  { path: '/vinagre', element: <VinegarPage /> },
  { path: '/suco', element: <JuicePage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
